import DevAuthAPI from "../api/DevAuth";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import ConsoleLocalStorage from "../storage/storage";

// query function
// async function getUser(user) {
//   const source = axios.CancelToken.source();

//   if (!user) return null;
//   const axiosResponse = await axiosInstance.get(`/user/${user.id}`, {
//     headers: getJWTHeader(user),
//     cancelToken: source.token,
//   });

//   axiosResponse.cancel = () => {
//     source.cancel();
//   };

//   return axiosResponse;
// }

export function useUser() {
  const [token] = useState(ConsoleLocalStorage.getAccessToken());
  const [user, setUser] = useState(ConsoleLocalStorage.getUser());
  // const queryClient = useQueryClient();

  // call useQuery to update user data from server
  useQuery(
    "user",
    async () => {
      let api = new DevAuthAPI();
      const res = await api.getDeveloper(user.id);
      return res.data.data;
    },
    {
      enabled: !!token && !!user?.id,
      onSuccess: (data) => {
        ConsoleLocalStorage.setUser(data);
        setUser(data);
      },
      onError: () => {
        localStorage.clear();
        // ConsoleLocalStorage.setUser("");
        setUser(null);
      },
    }
  );

  // meant to be called from useAuth
  function updateUser(newUser) {
    // set user in state
    setUser(newUser);

    // update user in localstorage
    ConsoleLocalStorage.setUser(newUser);

    // pre-populate user profile in React Query client
    // queryClient.setQueryData(queryKeys.user, newUser);
  }

  // // meant to be called from useAuth
  // function clearUser() {
  //   // update state
  //   setUser(null);

  //   // remove from localstorage
  //   clearStoredUser();

  //   // reset user to null in query client
  //   queryClient.setQueryData(queryKeys.user, null);

  //   // remove user appointments query
  //   queryClient.removeQueries([queryKeys.appointments, queryKeys.user]);
  // }

  // return { user, updateUser, clearUser };
  return { user, updateUser };
}